import { buildScheduleForEditing } from "./macro-conversion"

export function buildEditableIntro(intro, macroMap) {
    if (!intro) return intro
    return buildScheduleForEditing({ intro }, macroMap)?.intro ?? intro
}

export function buildEditableLeadingSummary(leadingSummary, macroMap) {
    if (!leadingSummary) return leadingSummary
    return buildScheduleForEditing({ intro: leadingSummary }, macroMap)?.intro ?? leadingSummary
}

export function buildEditableTask(task, macroMap) {
    if (!task) return task
    return buildScheduleForEditing({ tasks: [task] }, macroMap)?.tasks?.[0] ?? task
}

export function buildEditableTasks(tasks, macroMap) {
    if (!tasks?.length) return tasks
    return buildScheduleForEditing({ tasks }, macroMap)?.tasks ?? tasks
}

export function areEditableTaskValuesEqual(left = {}, right = {}) {
    return (
        left?.title === right?.title &&
        left?.content === right?.content &&
        left?.note === right?.note &&
        left?.temporaryTaskId === right?.temporaryTaskId &&
        left?.taskId === right?.taskId
    )
}

export function areEditableTaskListsEqual(left = [], right = []) {
    if (left === right) return true
    if (left.length !== right.length) return false

    for (let index = 0; index < left.length; index += 1) {
        if (!areEditableTaskValuesEqual(left[index], right[index])) return false
    }

    return true
}
